import { useEffect, useState } from "react";
import { AiFillBackward } from "react-icons/ai";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useUpdateProServiceMutation } from "../../features/api/proserviceApi";
import NewClient from "./NewClient";

const ViewUpdateProService = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const productInfo = location?.state;

  console.log(productInfo);

  const user = JSON.parse(localStorage.getItem("user"));

  const [id, setId] = useState("");
  const [p_r_date, setProRecvDate] = useState("");
  const [claim_date, setClaimDate] = useState("");
  const [sub_catName, setSubCategory] = useState("");
  const [pro_name, setProduct] = useState("");
  const [war_type, setWarrantyType] = useState("");
  const [job_no, setJobNo] = useState("");
  const [client_name, setDealerName] = useState("");
  const [c_address, setClientAddress] = useState("");
  const [mobile_no, setMobileNo] = useState("");
  const [complain_type, setComplainType] = useState("");
  const [model, setModel] = useState("");
  const [slNo, setSlNo] = useState("");
  const [nature_claim, setNatureOfClaims] = useState("");

  const [service_type, setServiceType] = useState("");
  const [service_details, setServiceDetails] = useState("");
  const [prev_jobNo, setPrevJobNo] = useState("");
  const [prev_job_date, setPrevJobDate] = useState();
  const [p_rcve_loc, setProRcvLocation] = useState("");

  const [job_done_by, setJobDoneBy] = useState("");
  const [delivery_status, setDeliveryStatus] = useState("");
  const [delivery_date, setDeliveryDate] = useState();
  const [delivered_by, setDeliveredBy] = useState("");
  const [del_app_date, setAppDeliveryDate] = useState();
  const [rcv_by, setReceiveBy] = useState("");
  const [remarks, setDescription] = useState("");

  useEffect(() => {
    if (productInfo) {
      setId(productInfo.id || "");
      setProRecvDate(productInfo.p_r_date || "");
      setClaimDate(productInfo.claim_date || "");
      setJobNo(productInfo.job_no || "");
      setDealerName(productInfo.client || "");
      setClientAddress(productInfo.address || "");
      setMobileNo(productInfo.mobile || "");
      setSubCategory(productInfo.brand || "");
      setProduct(productInfo.product || "");
      setModel(productInfo.model || "");
      setSlNo(productInfo.slNo || "");
      setWarrantyType(productInfo.war_type || "");
      setComplainType(productInfo.complain_type || "");

      setNatureOfClaims(productInfo.nature_claim || "");
      setServiceType(productInfo.service_type || "");
      setServiceDetails(productInfo.service_details || "");
      setPrevJobNo(productInfo.prev_jobNo || "");
      setPrevJobDate(productInfo.prev_job_date);
      setProRcvLocation(productInfo.p_rcve_loc || "");
      setJobDoneBy(productInfo.job_done_by || "");
      setDeliveryStatus(productInfo.delivery_status || "");
      setDeliveryDate(productInfo.delivery_date);
      setDeliveredBy(productInfo.delivered_by || "");
      setAppDeliveryDate(productInfo.del_app_date);
      setReceiveBy(productInfo.rcv_by);
      setDescription(productInfo.remarks || "");
    }
  }, [productInfo]);

  const [updateProService] = useUpdateProServiceMutation();

  const handleUpdateProductService = async () => {
    const data = {
      id,
      slNo,
      complain_type,
      war_type,

      nature_claim,
      p_rcve_loc,
      service_type,
      service_details,
      prev_jobNo,
      prev_job_date,

      delivery_status,
      delivery_date,
      job_done_by,
      delivered_by,
      del_app_date,
      rcv_by,
      remarks,
    };

    try {
      const response = await updateProService(data);
      console.log(response);
      const updateId = response?.data?.updateId;
      if (updateId) {
        if (delivery_status === "Delivered") {
          navigate(`/dashboard/product-service/job-report/${updateId}`);
        } else {
          navigate(`/dashboard/product-services`);
        }
        toast.success("success");
      }
    } catch (error) {
      console.error("Error updating data:", error?.response);
    }
  };
  return (
    <div className="lg:h-[89vh] mx-auto overflow-auto  bg-[#dbd7d7]">
      <div className="p-4">
        <div className="flex items-center justify-end gap-x-2">
          <NewClient />
          <Link
            to="/dashboard/product-services"
            className="bg-blue-500 px-2 py-1 rounded text-white flex items-center gap-x-1"
          >
            <AiFillBackward /> Back{" "}
          </Link>
        </div>
        <h1 className="text-2xl font-bold text-center">
          Product Service Center
        </h1>
      </div>
      <div className="">
        {/* <div className="p-4 m-4 border">
          <h2 className="font-bold mb-4 text-xl bg-blue-500  text-center">
            Service Product Information
          </h2>
          <form className=" grid grid-cols-1 lg:grid-cols-2  gap-6">
            <div className="flex gap-1">
              <label className="w-[40%]">Product Receive Date</label>
              <input
                type="date"
                value={p_r_date}
                // onChange={(e) => setProRecvDate(e.target.value)}
                disabled
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              />
            </div>
            <div className="flex gap-1">
              <label className=" w-[40%]">Claim Date</label>
              <input
                type="date"
                value={claim_date}
                disabled
                // onChange={(e) => setClaimDate(e.target.value)}
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              />
            </div>
            <div className="flex gap-1">
              <label className="w-[40%]">Job No</label>
              <input
                type="text"
                value={job_no}
                disabled
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              />
            </div>

            <div className="flex gap-1">
              <label className="w-[40%]">Client Name</label>
              <input
                type="text"
                value={client_name}
                disabled
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              />
            </div>

            <div className="flex gap-1">
              <label className="w-[40%]">Client Address</label>

              <textarea
                value={c_address}
                disabled
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              />
            </div>
            <div className="flex gap-1">
              <label className="w-[40%]">Mobile No.</label>
              <input
                type="text"
                value={mobile_no}
                disabled
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              />
            </div>
            <div className="flex gap-1">
              <label className="w-[40%]">Brand Name</label>
              <input
                type="text"
                value={sub_catName}
                disabled
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              />
            </div>
            <div className="flex gap-1">
              <label className="w-[40%]">Product</label>
              <input
                type="text"
                value={pro_name}
                disabled
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              />
            </div>
            <div className="flex gap-1">
              <label className="w-[40%]">Model</label>
              <input
                type="text"
                value={model}
                disabled
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              />
            </div>

            <div className="flex gap-1">
              <label className="w-[40%]">P. Serial No.</label>
              <input
                type="text"
                value={slNo}
                // onChange={(e) => setSlNo(e.target.value)}
                disabled
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              />
            </div>
            <div className="flex gap-1">
              <label className="w-[40%]">Warranty Type</label>
              <select
                value={war_type}
                // onChange={(e) => setWarrantyType(e.target.value)}
                disabled
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              >
                <option value="">--select--</option>
                <option value="Warranty">Warranty</option>
                <option value="Non-Warranty">Non-Warranty</option>
                <option value="Others">Others</option>
              </select>
            </div>

            <div className="flex gap-1">
              <label className="w-[40%]">Complain Type</label>
              <select
                value={complain_type}
                // onChange={(e) => setComplainType(e.target.value)}
                disabled
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              >
                <option value="">--select--</option>
                <option value="Regular">Regular</option>
                <option value="Re-complain">Re-complain</option>
              </select>
            </div>
          </form>
        </div> */}

        <div className="p-4 m-4 border bg-gray-300">
          <h2 className="font-semibold mb-4 text-xl bg-blue-500 text-white text-center py-1">
            Service Product Information
          </h2>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            <div className="flex items-center gap-2">
              <label className="min-w-[130px] font-medium">Receive Date</label>
              <div>: {p_r_date}</div>
            </div>
            <div className="flex items-center gap-2 ">
              <label className="min-w-[130px] font-medium">Claim Date</label>
              <div>: {claim_date}</div>
            </div>
            <div className="flex items-center gap-2">
              <label className="min-w-[130px] font-medium">Job No</label>
              <div>: {job_no}</div>
            </div>
            <div className="flex items-center gap-2">
              <label className="min-w-[130px] font-medium">Client Name</label>
              <div>: {client_name}</div>
            </div>
            <div className="flex items-center gap-2">
              <label className="min-w-[130px] font-medium">
                Client Address
              </label>
              <div className="whitespace-pre-wrap">: {c_address}</div>
            </div>
            <div className="flex items-center gap-2">
              <label className="min-w-[130px] font-medium">Mobile No.</label>
              <div>: {mobile_no}</div>
            </div>
            <div className="flex items-center gap-2">
              <label className="min-w-[130px] font-medium">Brand Name</label>
              <div>: {sub_catName}</div>
            </div>
            <div className="flex items-center gap-2">
              <label className="min-w-[130px] font-medium">Product</label>
              <div>: {pro_name}</div>
            </div>
            <div className="flex items-center gap-2">
              <label className="min-w-[130px] font-medium">Model</label>
              <div>: {model}</div>
            </div>
            <div className="flex items-center gap-2">
              <label className="min-w-[130px] font-medium">P. Serial No.</label>
              <div>: {slNo}</div>
            </div>
            <div className="flex items-center gap-2">
              <label className="min-w-[130px] font-medium">Warranty Type</label>
              <div>: {war_type}</div>
            </div>
            <div className="flex items-center gap-2">
              <label className="min-w-[130px] font-medium">Complain Type</label>
              <div>: {complain_type}</div>
            </div>
          </div>
        </div>

        <div className="p-4 m-4 border bg-gray-200">
          <h2 className="font-semibold mb-4 text-xl bg-blue-500 text-white text-center py-1">
            Service Details Information
          </h2>
          <form className=" grid grid-cols-1 lg:grid-cols-2  gap-6">
            <div className="flex gap-1">
              <label className=" w-[40%]">Nature of Claims</label>

              <textarea
                value={nature_claim}
                onChange={(e) => setNatureOfClaims(e.target.value)}
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              />
            </div>

            <div className="flex gap-1">
              <label className=" w-[40%]">Product Receive Location</label>
              <select
                value={p_rcve_loc}
                onChange={(e) => setProRcvLocation(e.target.value)}
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              >
                <option value="">--select--</option>
                <option value="Dhaka">Dhaka</option>
                <option value="Chattagram">Chattagram</option>
              </select>
            </div>

            <div className="flex gap-1">
              <label className=" w-[40%]">Service Type</label>
              <select
                value={service_type}
                onChange={(e) => setServiceType(e.target.value)}
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              >
                <option value="">--select--</option>
                <option value="Indoor">Indoor</option>
                <option value="Out Door">Out Door</option>
              </select>
            </div>
            <div className="flex gap-1">
              <label className=" w-[40%]">Service Details</label>
              <textarea
                value={service_details}
                onChange={(e) => setServiceDetails(e.target.value)}
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              />
            </div>
            <div className="flex gap-1">
              <label className=" w-[40%]">Previous Job No.</label>
              <input
                type="text"
                value={prev_jobNo}
                onChange={(e) => setPrevJobNo(e.target.value)}
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              />
            </div>
            <div className="flex gap-1">
              <label className=" w-[40%]">Previous Job Date</label>
              <input
                type="date"
                value={prev_job_date}
                onChange={(e) => setPrevJobDate(e.target.value)}
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              />
            </div>
            <div className="flex gap-1">
              <label className=" w-[40%]">Job Receive By</label>
              <input
                type="text"
                value={rcv_by}
                onChange={(e) => setReceiveBy(e.target.value)}
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              />
            </div>
            <div className="flex gap-1">
              <label className=" w-[40%]"> Delivery Date ( Approx )</label>
              <input
                type="date"
                value={del_app_date}
                onChange={(e) => setAppDeliveryDate(e.target.value)}
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              />
            </div>

            {/* <div className="flex gap-1">
              <label className=" w-[40%]">Present Status</label>
              <select
                value={working_status}
                onChange={(e) => setWorkingStatus(e.target.value)}
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              >
                <option value="">--select--</option>
                <option value="Pending">Pending</option>
                <option value="Under Repair">Under Repair</option>
                <option value="Done Successfully">Done Successfully</option>
              </select>
            </div> */}

            <div className="flex gap-1">
              <label className=" w-[40%]">Service Status</label>
              <select
                value={delivery_status}
                onChange={(e) => setDeliveryStatus(e.target.value)}
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              >
                <option value="">--select--</option>
                <option value="Pending">Pending</option>
                <option value="Under Repair">Under Repair</option>
                <option value="Repair not possible">Repair not possible</option>
                <option value="Ready for Delivery">Ready for Delivery</option>
                <option value="Delivered">Delivered</option>
              </select>
            </div>
            <div className="flex gap-1">
              <label className=" w-[40%]">Delivery Date</label>
              <input
                type="date"
                value={delivery_date}
                onChange={(e) => setDeliveryDate(e.target.value)}
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              />
            </div>

            <div className="flex gap-1">
              <label className=" w-[40%]">Job Done By</label>
              <input
                type="text"
                value={job_done_by}
                onChange={(e) => setJobDoneBy(e.target.value)}
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              />
            </div>

            <div className="flex gap-1">
              <label className=" w-[40%]">Remarks</label>
              <textarea
                value={remarks}
                onChange={(e) => setDescription(e.target.value)}
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              />
            </div>
            <div className="flex gap-1">
              <label className=" w-[40%]">Delivered By</label>
              <input
                type="text"
                defaultValue={user?.role}
                onChange={(e) => setDeliveredBy(e.target.value)}
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              />
            </div>
          </form>
        </div>

        <div className="flex justify-end px-4">
          <button
            onClick={handleUpdateProductService}
            className=" px-4 py-1 rounded bg-blue-500 text-white mb-4"
          >
            Update
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewUpdateProService;
